module.exports = __webpack_public_path__ + "img/ship_enemy2.9ed0dd74.png";